export class Slot {
    private value:string;

    constructor(value: any) {
        if(value instanceof Date){
            this.BuildFromDate(value);
        }else if(typeof value === 'string'){
            this.BuildFromString(value);
        }else{
            throw new Error('Bad Slot format');
        }
    }

    public SameDay(other:Slot):boolean{
        let slotAsString:Array<string> = this.value.split('-');
        let otherAsString:Array<string> = other.value.split('-');

        if(slotAsString.length != otherAsString.length){
            return false;
        }

        return slotAsString[0] == otherAsString[0] &&
            slotAsString[1] == otherAsString[1] &&
            slotAsString[2] == otherAsString[2] &&
            slotAsString[3] != otherAsString[3];
    }

    public Value(): string{
        return this.value;
    }

    public Date(): Date{
        let date:Date = new Date(this.value.substring(0, this.value.length - 3));
        if(this.value.endsWith('-PM')){
            date.setHours(13);
        }else{
            date.setHours(1);
        }
        return date;
    }

    public Equals(other:Slot):boolean{
        return this.value == other.Value();
    }

    public IsBefore(other:Slot):boolean{
        return this.Date() < other.Date();
    }

    public IsAfter(other:Slot):boolean{
        return this.Date() > other.Date();
    }

    public Next():Slot{
        let date = this.Date();
        date.setTime(date.getTime() + (12 * 60 * 60 * 1000));
        return new Slot(date);
    }

    public Previous():Slot{
        let date = this.Date();
        date.setTime(date.getTime() - (12 * 60 * 60 * 1000));
        return new Slot(date);
    }

    public Day():number{
        return +this.value.split('-')[2]
    }

    public IsMorning():boolean{
        return this.value.endsWith('AM');
    }

    private BuildFromString(value:string){
        if(!value.endsWith('-AM') && !value.endsWith('-PM')){
            throw new Error('Bad Slot format');
        }
        if(isNaN(new Date(value.substring(0, value.length - 3)).getFullYear())){
            throw new Error('Bad Slot format');
        }
        this.value = value;
    }

    private BuildFromDate(value:Date){
        let stringValue:string = "";
        stringValue += value.getFullYear() + "-";

        let month:number = value.getMonth() + 1;
        stringValue += (month < 10 ? "0" + month : month) + "-";

        let day:number = value.getDate();
        stringValue += (day < 10 ? "0" + day : day) + "-";

        let hour:number = value.getHours();
        stringValue += hour > 12 ? "PM" : "AM";

        this.BuildFromString(stringValue);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/calendar/Slot.ts